import { useContext, useState } from "react";
import { LoaderContext } from "../AuthContext/AuthContext";
import { GetCheckCouponCode } from "../ApiServices/CouponCode/CouponCodeApi";
import { t } from "i18next";

const useApplyCouponCode = ({
    apiParam,
    setIsCouponApplied,
    setAppliedCoupon,
    setIsWalletApplied,
}) => {
    const { setLoader } = useContext(LoaderContext);
    const [isApplying, setIsApplying] = useState(false);

    const applyCoupon = async (couponCode, updatedApiParam = apiParam) => {
        const enteredCode = couponCode?.trim();

        if (!enteredCode) {
            return {
                success: false,
                message: t("Please enter coupon code"),
            };
        }

        setIsApplying(true);
        setLoader(true);

        try {
            const payload = {
                ...updatedApiParam,
                couponCode: enteredCode,
            };


            const response = await GetCheckCouponCode(payload);

            if (response?.statusCode !== 200) {
                return {
                    success: false,
                    message:
                        response?.errorMessage ||
                        response?.message ||
                        t("Unable to apply coupon"),
                };
            }

            const coupon = response?.responseData?.data;

            if (!coupon) {
                return {
                    success: false,
                    message: t("Invalid coupon code"),
                };
            }

            // Check coupon validation status from API
            if (coupon?.visibilityStatus !== true) {
                return {
                    success: false,
                    message:
                        coupon?.visibilityNote ||
                        t("Coupon is not applicable"),
                };
            }

            // Coupon is valid → apply it
            setIsWalletApplied(false);

            setAppliedCoupon((prev) => ({
                ...prev,
                couponCode: coupon?.couponCode,
                isApplied: true,
                CoupenAmount: coupon?.coupenAmount,
                couponAmount: coupon?.coupenAmount,
                couponCodeID: coupon?.couponCodeID,
                walletAmount: 0,
            }));

            setIsCouponApplied(true);

            return {
                success: true,
                message:
                    coupon?.visibilityNote ||
                    t("Coupon applied successfully"),
                coupon,
            };

        } catch (error) {
            console.error("Apply Coupon Error:", error);

            return {
                success: false,
                message: t("Unable to apply coupon"),
            };
        } finally {
            setLoader(false);
            setIsApplying(false);
        }
    };

    return {
        applyCoupon,
        isApplying,
    };
};

export default useApplyCouponCode;
